import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, _mergeProps({
    "model-value": _ctx.modelValue,
    label: "Search clients",
    "clear-icon": "fa fa-times",
    clearable: ""
  }, _ctx.$attrs, {
    "onUpdate:modelValue": _ctx.delayedSearch,
    onClear: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', null)))
  }), {
    prepend: _withCtx(() => [
      _createVNode(_component_q_icon, { name: "fa fa-search" })
    ]),
    _: 1
  }, 16, ["model-value", "onUpdate:modelValue"]))
}